import type { AnchorHTMLAttributes, MouseEvent } from 'react'
import { href as toHref, navigate, type Route } from './router'

/** A real link: middle-click and copy-link work, and a plain click stays in the app. */
export function Link({ to, onClick, ...rest }: Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & { to: Route }) {
  const url = toHref(to)
  return (
    <a
      href={url}
      onClick={(event: MouseEvent<HTMLAnchorElement>) => {
        onClick?.(event)
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
        event.preventDefault()
        navigate(url)
      }}
      {...rest}
    />
  )
}
